var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.viewBoxAddWidth}},[_c('g',{attrs:{"fill":_vm.color}},[_c('polygon',{attrs:{"points":"0 0 3.3 3 3.3 0 0 0"}}),_c('rect',{attrs:{"x":"3.2","y":"0.01","width":_vm.width,"height":"3"}}),_c('polygon',{attrs:{"points":_vm.polygonPointsAddWidth}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }